import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../Config/flagstoneTheme';


export default function AlertDialog(props) {

    const classes = useStyles();

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose = {props.closeDialog}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    {props.dialogContext}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.okButton} autoFocus onClick={props.action}>
                        OK
                 </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "50px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        cursor: 'move',
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    }   
}));
